export default function AllocationSummary({ allocation }) {
  if (!allocation) return null;

  const resource = allocation.member?.name ?? allocation.placeholder?.name;
  const assignment = allocation.project?.name ?? allocation.timeOffType?.name;

  return [assignment, resource].filter(Boolean).join(' - ');
}
